import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (
    siteId: string,
    manifestationId?: string,
    locatairePermanentId?: string,
    typeEtatDesLieux?: EtatDesLieuxTypeEnum
  ) => {
    return fetchPages<EtatDesLieuxResponse>(
      'etatDesLieuxList',
      config.ws.edl.all +
        `?siteId=${siteId}${!!manifestationId ? `&manifestationId=${manifestationId}` : ''}${
          !!locatairePermanentId ? `&locatairePermanentId=${locatairePermanentId}` : ''
        }${!!typeEtatDesLieux ? `&typeEtatDesLieux=${typeEtatDesLieux}` : ''}`,
      'GET'
    )
  },
  get: (id: string) => {
    return ws<EtatDesLieuxResponse>(config.ws.edl.get.replace('{id}', id), 'GET')
  },
  incidents: (body: EtatDesLieuxIncidentFiltreRequest) => {
    return ws<IncidentTokenResponse>(config.ws.edl.incidents, 'POST', body)
  },
  send: (body: EtatDesLieuxCreationRequest) => {
    return ws<EtatDesLieuxResponse>(config.ws.edl.send, 'POST', body)
  },
  sync: (id: string) => ws<void>(config.ws.edl.sync.replace('{id}', id), 'POST'),
}

export default api
